module.exports = __webpack_public_path__ + "static/media/logo-mastercard.ff6919d8.svg";